import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import MenuIcon from "@material-ui/icons/Menu";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import {
  portOperationHeader,
  portOperationDisabledFields,
  operationsOptions,
  loadlineOptions,
  termsCoEfficientTable,
  portEmissionOptions,
} from "../../constants";
import errorIcon from "../../assets/images/info-circle-line-icon.svg";
import PlusIcon from "../../assets/icons/plus.png";

import { handleKeyDown } from "../../common/common";
import Tooltip from "../../common/Tooltip";
import { fmt3 } from "../../utils";

const DragHandle = SortableHandle(() => (
  <span style={{ cursor: "grab", touchAction: "none", userSelect: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
    <MenuIcon />
  </span>
));

const SortableItem = SortableElement((props) => {
  return (
    <div
      className="sortable-row-tr"
      style={{ userSelect: "none" }}
    >
      {props.children}
    </div>
  );
});

const DraggableList = SortableContainer((props) => {
  let {
    combinedOperation = [],
    onDeleteOperations = () => { },
    onChangePortOperations = () => { },
    onClickSinglePort = () => { },
    showFreightSelection = false,
    cargoTxOverride = false,
    dischargedPortIndexes = [],
    setOpenAddOperation = () => { },
    setOpenAddOperationindex = () => { },
    disableEdit = false,
    selectedColumns = [],
  } = props;

  let currentHeader = [...portOperationHeader];
  if (showFreightSelection) {
    currentHeader.splice(14, 0, {
      label: "Freight",
      width: 50,
    });
  }

  const getStyleByLabel = (label, fallbackIndex) => {
    let item;
    if (label !== undefined && label !== null && label !== "") {
      item = currentHeader.find((h) => h.label === label);
    }
    if (!item && fallbackIndex !== undefined) {
      item = currentHeader[fallbackIndex];
    }
    const width = item ? item.width : 50;
    return {
      minWidth: width,
      width,
      flex: `${width} 0 ${width}px`,
    };
  };

  const isColumnVisible = (label) => {
    if (!selectedColumns || selectedColumns.length === 0) return true;
    if (label === "") return true;
    return selectedColumns.includes(label);
  };

  return (
    <div className="sortable-div">
      {combinedOperation &&
        combinedOperation.map((operations, index) => {
          const checkDisabled =
            portOperationDisabledFields[operations.operation] || {};
          const {
            bunkerSuppliedHSFO = 0,
            bunkerSuppliedLSFO = 0,
            bunkerSuppliedMGO = 0,
            distNormal = 0,
            distNormalSystem = 0,
            distEca = 0,
            distEcaSystem = 0,
          } = operations.cargoDetails || {};
          const totalSupply =
            Number(bunkerSuppliedHSFO) +
            Number(bunkerSuppliedLSFO) +
            Number(bunkerSuppliedMGO);

          let dischargedPort = dischargedPortIndexes.includes(index);
          let operationLbmarker =
            operations.lbmarker === "ballast"
              ? "B"
              : operations.lbmarker === "laden"
                ? "L"
                : "";
          const itemKey = operations.id || operations._id || `${operations.operation}_${operations.port || ""}_${index}`;
          return (
            <SortableItem key={itemKey} index={index}>
              {isColumnVisible("Add Opr..") && (
                !disableEdit ? (
                  <div
                    className="sortable-div-operation operation-input-div custom-tooltip-div"
                    onClick={() => {
                      setOpenAddOperation(true);
                      setOpenAddOperationindex(index + 1);
                    }}
                    style={getStyleByLabel("Add Opr..", 0)}
                  >
                    <img src={PlusIcon} className="operation-plus-icon" slt="" />
                    <div className="tooltip-notification">
                      <p>Add operation in next row</p>
                    </div>
                  </div>
                ) : (
                  ""
                )
              )}
              {isColumnVisible("") && (
                <div className="operation-input-div" style={getStyleByLabel("", 1)}>
                  {!disableEdit && (index === 0 ? <MenuIcon /> : <DragHandle />)}
                </div>
              )}
              {isColumnVisible("B/L") && (
                <div className="operation-input-div justify-center text-center" style={getStyleByLabel("B/L", 2)}>
                  <span className="w-full text-center">{operationLbmarker}</span>
                </div>
              )}
              {isColumnVisible("Operation") && (
                <div className="operation-input-div" style={getStyleByLabel("Operation", 3)}>
                  {/* {operations.operation || 0} */}
                  <select
                    value={operations.operation || ""}
                    name="operation"
                    onChange={(e) => onChangePortOperations(index, e)}
                    disabled={checkDisabled.operation}
                  >
                    {operationsOptions.map((option, key) => (
                      <option
                        key={key}
                        value={option.value}
                        disabled={option.isDisabled}
                      >
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {isColumnVisible("Port") && (
                <div className="operation-input-div" style={getStyleByLabel("Port", 4)}>
                  <p
                    className={`add-three-dots${
                      index === 0 ||
                      operations.operation === "Loading" ||
                      operations.operation === "Discharging"
                        ? " port-disabled"
                        : ""
                    }`}
                    onClick={() => {
                      if (
                        index === 0 ||
                        operations.operation === "Loading" ||
                        operations.operation === "Discharging"
                      )
                        return;
                      onClickSinglePort(operations, index);
                    }}
                  >
                    {operations.port || ""}
                  </p>
                </div>
              )}
              {isColumnVisible("Dist Normal") && (
                <div
                  className="operation-input-div flex items-center"
                  style={getStyleByLabel("Dist Normal", 5)}
                >
                  {/* dist normal */}
                  <Tooltip
                    text={"Value edited by user"}
                    position="top"
                    open={
                      (distNormalSystem || 0) !== (distNormal || 0)
                        ? undefined
                        : false
                    }
                  >
                    <div className="flex items-center">
                      <input
                        type="number"
                        onKeyDown={handleKeyDown}
                        value={distNormal || ""}
                        placeholder="0"
                        disabled={!!checkDisabled.distNormal}
                        name="distNormal"
                        className={`${(distNormalSystem || 0) == (distNormal || 0)
                          ? ""
                          : "bg-[#ffd2b5] text-black"
                          }`}
                        onChange={(e) => onChangePortOperations(index, e, true)}
                      />
                    </div>
                  </Tooltip>
                </div>
              )}
              {isColumnVisible("Dist ECA") && (
                <div
                  className="operation-input-div flex items-center"
                  style={getStyleByLabel("Dist ECA", 6)}
                >
                  {/* dist eca */}
                  <Tooltip
                    text={"Value edited by user"}
                    position="top"
                    open={
                      (distEcaSystem || 0) !== (distEca || 0) ? undefined : false
                    }
                  >
                    <div className="flex items-center">
                      <input
                        type="number"
                        value={distEca || ""}
                        onKeyDown={handleKeyDown}
                        placeholder="0"
                        disabled={!!checkDisabled.distEca}
                        name="distEca"
                        className={`${(distEcaSystem || 0) == (distEca || 0)
                          ? ""
                          : "bg-[#ffd2b5] text-black"
                          }`}
                        onChange={(e) => onChangePortOperations(index, e, true)}
                      />
                    </div>
                  </Tooltip>
                </div>
              )}
              {isColumnVisible("DWF") && (
                <div className="operation-input-div" style={getStyleByLabel("DWF", 7)}>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.dwf || ""}
                    disabled={!!checkDisabled.dwf}
                    name="dwf"
                    placeholder="0"
                    onChange={(e) => onChangePortOperations(index, e)}
                  />
                </div>
              )}
              {isColumnVisible("Speed Normal") && (
                <div className="operation-input-div" style={getStyleByLabel("Speed Normal", 8)}>
                  <span className="port-operation-cell-value">
                    {operations.speedNormal || 0}
                  </span>
                </div>
              )}
              {isColumnVisible("Speed ECA") && (
                <div className="operation-input-div" style={getStyleByLabel("Speed ECA", 9)}>
                  <span className="port-operation-cell-value">
                    {operations.speedECA || 0}
                  </span>
                </div>
              )}
              {isColumnVisible("Cargo Tx") && (
                <div className="operation-input-div" style={getStyleByLabel("Cargo Tx", 10)}>
                  {/*  cargo tx */}
                  {cargoTxOverride && dischargedPort ? (
                    <input
                      type="number"
                      onKeyDown={handleKeyDown}
                      value={operations.cargoTxOverriddenValue || ""}
                      // disabled={!!checkDisabled.dwf}
                      placeholder="0"
                      name="cargoTxOverriddenValue"
                      onChange={(e) => onChangePortOperations(index, e)}
                    />
                  ) : (
                    <span className="port-operation-cell-value">
                      {operations.cargoTx || ""}
                    </span>
                  )}
                </div>
              )}
              {isColumnVisible("Rate MT/day") && (
                <div className="operation-input-div" style={getStyleByLabel("Rate MT/day", 11)}>
                  {/*  rate MT day */}
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.rate || ""}
                    disabled={!!checkDisabled.rate}
                    name="rate"
                    placeholder="0"
                    onChange={(e) => onChangePortOperations(index, e)}
                  />
                </div>
              )}
              {isColumnVisible("Terms") && (
                <div className="operation-input-div" style={getStyleByLabel("Terms", 12)}>
                  {/* {operations.terms}  */}
                  <select
                    value={operations.terms || ""}
                    name="terms"
                    onChange={(e) => onChangePortOperations(index, e)}
                    disabled={checkDisabled.terms}
                  >
                    {termsCoEfficientTable.map((option, key) => (
                      <option key={key} value={option.label}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {isColumnVisible("Factor") && (
                <div className="operation-input-div" style={getStyleByLabel("Factor", 13)}>
                  <p>{operations.factor}</p>
                </div>
              )}
              {showFreightSelection && isColumnVisible("Freight") ? (
                <div className="operation-input-div" style={getStyleByLabel("Freight")}>
                  {/* {operations.turnTime} */}
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.freight || ""}
                    disabled={!!checkDisabled.freight}
                    name="freight"
                    placeholder="0"
                    onChange={(e) => onChangePortOperations(index, e)}
                  />
                </div>
              ) : null}
              {isColumnVisible("Turn time(d)") && (
                <div className="operation-input-div" style={getStyleByLabel("Turn time(d)")}>
                  {/* {operations.turnTime} */}
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.turnTime || ""}
                    disabled={!!checkDisabled.turnTime}
                    name="turnTime"
                    placeholder="0"
                    onChange={(e) => onChangePortOperations(index, e)}
                  />
                </div>
              )}
              {isColumnVisible("Extra days") && (
                <div className="operation-input-div" style={getStyleByLabel("Extra days")}>
                  {/* {operations.extraDays} */}
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.extraDays || ""}
                    disabled={!!checkDisabled.extraDays}
                    name="extraDays"
                    onChange={(e) => onChangePortOperations(index, e)}
                  />
                </div>
              )}
              {isColumnVisible("Port Exp") && (
                <div className="operation-input-div" style={getStyleByLabel("Port Exp")}>
                  {/* {operations.portExp} */}
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.portExp || ""}
                    disabled={!!checkDisabled.portExp}
                    name="portExp"
                    placeholder="0"
                    onChange={(e) => onChangePortOperations(index, e)}
                  />
                </div>
              )}
              {isColumnVisible("Port stay") && (
                <div className="operation-input-div" style={getStyleByLabel("Port stay")}>
                  <p>{fmt3(Number(operations.portStay || 0))}</p>
                </div>
              )}
              {isColumnVisible("Port Emission") && (
                <div className="operation-input-div" style={getStyleByLabel("Port Emission")}>
                  {/*  Port Emission */}
                  <select
                    value={operations.sulfur || ""}
                    name="sulfur"
                    onChange={(e) => onChangePortOperations(index, e)}
                    disabled={checkDisabled.sulfur}
                  >
                    {portEmissionOptions.map((option, key) => (
                      <option key={key} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {isColumnVisible("Loadline") && (
                <div className="operation-input-div" style={getStyleByLabel("Loadline")}>
                  {/* {operations.loadline} */}
                  <select
                    value={operations.loadline || ""}
                    name="loadline"
                    onChange={(e) => onChangePortOperations(index, e)}
                    disabled={checkDisabled.loadline}
                  >
                    {loadlineOptions.map((option, key) => (
                      <option key={key} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {isColumnVisible("Draft Res") && (
                <div className="operation-input-div" style={getStyleByLabel("Draft Res")}>
                  {/* {operations.draftRes} */}
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={operations.draftRes || ""}
                    disabled={!!checkDisabled.draftRes}
                    name="draftRes"
                    placeholder="0"
                    onChange={(e) => onChangePortOperations(index, e)}
                  />
                </div>
              )}
              {isColumnVisible("Water Den") && (
                <div className="operation-input-div" style={getStyleByLabel("Water Den")}>
                  {/* {operations.waterDensity} */}
                  <div
                    className={`custom-input-outer ${Number(operations.waterDensity) > 0 &&
                      (Number(operations.waterDensity) < 0.9 ||
                        Number(operations.waterDensity) > 1.05) &&
                      "req-error"
                      }`}
                  >
                    <input
                      type="number"
                      onKeyDown={handleKeyDown}
                      value={operations.waterDensity || ""}
                      placeholder="0"
                      disabled={!!checkDisabled.waterDensity}
                      name="waterDensity"
                      onChange={(e) => onChangePortOperations(index, e)}
                    />
                    <div className="error-notification">
                      <Tooltip
                        text={`${operations?.operation} Water Density seems impractical`}
                        position="top"
                      >
                        <img
                          src={errorIcon}
                          alt="Show water density validation error"
                          tabIndex={0}
                        />
                      </Tooltip>
                    </div>
                  </div>
                </div>
              )}
              {isColumnVisible("Supply") && (
                <div className="operation-input-div" style={getStyleByLabel("Supply")}>
                  {/* {operations.supply} */}
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    value={totalSupply}
                    disabled
                  />
                </div>
              )}
              {isColumnVisible("") && (
                <div className="operation-input-div" style={getStyleByLabel("", currentHeader.length - 1)}>
                  {!!checkDisabled.canDelete && !disableEdit ? (
                    <DeleteIcon
                      onClick={() =>
                        onDeleteOperations(
                          index,
                          operations._id,
                          operations?.index
                        )
                      }
                    />
                  ) : null}
                </div>
              )}
            </SortableItem>
          );
        })}
    </div>
  );
});

export default DraggableList;
